import { useState } from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineCloud } from "react-icons/hi2";

import { SidebarNavElement } from "@/components/_templates/sidebar/sidebar-nav-element";
import { makeWorkspaceUrl } from "@/domain/workspace/lib/make-workspace-url";
import { Workspace } from "@/domain/workspace/models/workspace-model";

import { useGetInventoryList } from "../hooks/api/use-get-inventory-list";

interface InventorySidebarNavLinkProps {
  workspace: Workspace;
}

export const InventorySidebarNavLink = ({ workspace }: InventorySidebarNavLinkProps) => {
  const { t } = useTranslation("common");
  const [hasHovered, setHasHovered] = useState(false);

  useGetInventoryList({
    workspaceId: workspace.id,
    enabled: hasHovered,
    source: "sidebar-prefetch",
  });

  return (
    <SidebarNavElement
      to={makeWorkspaceUrl({ workspace: workspace, path: "inventories" })}
      onMouseEnter={() => {
        setHasHovered(true);
      }}
    >
      <HiOutlineCloud className="mr-2 h-3 w-3" />
      {t("navigation.inventories")}
    </SidebarNavElement>
  );
};
